module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"modal":{"confirm":"Confirmar","cancel":"Cancelar"}},"en":{"modal":{"confirm":"Confirm","cancel":"Cancel"}}}')
  delete Component.options._Ctor
}
